var React = require('react');

function Promo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#31ADED","fillRule":"evenodd","d":"M13.007 3L21 10.993 10.993 21H5.402A2.402 2.402 0 013 18.598v-5.591L13.007 3zm0 1.77L4.25 13.526v5.072A1.157 1.157 0 005.4 19.75h5.104l8.756-8.756-6.254-6.223zm0 3.721a2.502 2.502 0 110 5.004 2.502 2.502 0 010-5.004zm0 1.251a1.25 1.25 0 100 2.502 1.25 1.25 0 000-2.502z"}));
}

Promo.defaultProps = {"width":"24","height":"24"};

module.exports = Promo;

Promo.default = Promo;
